import React from "react";
import { Link, useLocation } from "react-router-dom";

const SidebarDropdown = ({ id, iconClass, label, children, basePath, activeDropdown, setActiveDropdown }) => {
    const location = useLocation();
    const isPathActive = location.pathname.startsWith(basePath); // Determine if the current route matches the basePath
    const isDropdownOpen = activeDropdown === id || (activeDropdown === null && isPathActive); // Use basePath logic when activeDropdown is null

    const toggleDropdown = () => {
        // Toggle the dropdown; if already active, set to null
        setActiveDropdown(isDropdownOpen ? null : id);
    };

    return (
        <li className={isDropdownOpen ? "mm-active" : ""}>
            <Link to="#" onClick={toggleDropdown}>
                <i className={`metismenu-icon ${iconClass}`}></i>
                {label}
                <i className={`right pe-7s-angle-down ${isDropdownOpen ? "rotated" : ""}`}></i>
            </Link>
            <ul className={`${isDropdownOpen ? "mm-show" : "mm-collapse"}`}>
                {children}
            </ul>
        </li>
    );
};

export default SidebarDropdown;
